import {
  Button,
  Divider,
  Form,
  Popconfirm,
  Row,
  Space,
  Spin,
  Typography,
  message,
} from "antd";
import React, {useEffect, useRef, useState} from "react";
import {columnsTable, fields} from "./config";
import Icon from "assets/icons";
import {InputFields} from "components/common";
import {glassStoreService} from "api";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {
  getListStore,
  getListStoreNhap,
  getListStorePhanQuyen,
  getListStoreXuat,
  getListSupplierAPI,
  getListXuatXuAPI,
  setDetailRecord,
  setSelectGlassExport,
  setSelectedRecord,
  setStatusPhieu,
  setTypeForm,
} from "redux/reducer/glassStore";
import TableInputAdd from "./TableInputAdd/TableInputAdd";
import moment from "moment";
import {LOAI_FORM, LOAI_PHIEU_KHO, TT_PHIEU_KHO, tabKeys} from "types/enums";
import Notification from "components/common/notification/notification";
import {randomId, toNumber} from "helper/common";
import {setKhoNhapId, setKhoXuatId} from "redux/reducer/tableAdd";
import {setActiveKey} from "redux/reducer/common";
import ModalDeny from "./ModalDeny/ModalDeny";
import ModalCustom from "components/common/ModalCustom/ModalCustom";
import ReceiptModal from "./ReceiptModal/ReceiptModal";
import dayjs from "dayjs";
const Detail = ref => {
  const dispatch = useAppDispatch();
  const modalRef = useRef<any>();
  const receiptRef = useRef<any>();
  const [formReceiptDto] = Form.useForm();
  const [formTable] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [loadingBtnComplete, setLoadingBtnComplete] = useState<boolean>(false);
  const [loadingBtnSend, setLoadingBtnSend] = useState<boolean>(false);
  const [loadingBtnSave, setLoadingBtnSave] = useState<boolean>(false);
  const [loadingBtnCancel, setLoadingBtnCancel] = useState<boolean>(false);
  const [dataFields, setDataFields] = useState(fields);
  const typeForm = useAppSelector(state => state.glassStore.typeForm);
  const typePhieu = useAppSelector(state => state.glassStore.typePhieu);
  const statusPhieu = useAppSelector(state => state.glassStore.statusPhieu);
  const [textTypePhieu, setTextTypePhieu] = useState<any>();
  const [textStatusPhieu, setTextStatusPhieu] = useState("");

  const [columns, setColumns] = useState(columnsTable);
  const [data, setData] = useState<any[]>([]);
  const [dataDeny, setDataDeny] = useState<any>();
  const glassStore = useAppSelector(state => state.glassStore);
  const selectedRecord = useAppSelector(
    state => state.glassStore.selectedRecord
  );
  const detailRecord = useAppSelector(state => state.glassStore.detailRecord);

  const selectedGlassExport = useAppSelector(
    state => state.glassStore.selectGlass
  );
  useEffect(() => {
    setFieldSupplierShow();
    setFieldSoHoaDonShow();
  }, [typePhieu]);

  useEffect(() => {
    setOptionsStore();
    setOnChangeStore();
  }, [glassStore.listStoreNhap, glassStore.listStoreXuat, typePhieu]);
  useEffect(() => {
    setOptionsSupplier();
  }, [glassStore.listSupplier]);
  const setOptionsSupplier = () => {
    dataFields.find(e => e.name == "nhaCungCap").options =
      glassStore.listSupplier.map(e => {
        return {key: randomId(), value: e?.name, label: e?.name};
      });

    setDataFields([...fields]);
  };
  const setOptionsStore = () => {
    dataFields.find(e => e.name == "khoNhapId").options =
      glassStore.listStoreNhap.map(e => {
        return {key: randomId(), value: e.id, label: e.name};
      });
    dataFields.find(e => e.name == "khoXuatId").options =
      glassStore.listStoreXuat.map(e => {
        return {key: randomId(), value: e.id, label: e.name};
      });
    setDataFields([...fields]);
  };
  useEffect(() => {
    if (typeForm == LOAI_FORM.TAO_MOI) {
      setData([]);
      formTable.setFieldValue("listGlassesReceiptDetailDto", []);

      formReceiptDto.resetFields();
      formReceiptDto.setFieldValue(
        "nguoiLap",
        localStorage.getItem("fullName")
      );
      formReceiptDto.setFieldValue("ngayHoaDon", dayjs());

      dispatch(setStatusPhieu(TT_PHIEU_KHO.NHAP));
      if (typePhieu == LOAI_PHIEU_KHO.XUAT) {
        if (selectedGlassExport.length == 0) {
          setData([]);
          formTable.setFieldValue("listGlassesReceiptDetailDto", []);
        } else {
          formReceiptDto.setFieldValue(
            "khoXuatId",
            selectedGlassExport[0]?.khoId
          );
        }
      }
    }
  }, [typeForm, typePhieu]);
  useEffect(() => {
    const setDefaultStore = () => {
      if (typeForm == LOAI_FORM.TAO_MOI) {
        const khoUserId =
          Number(localStorage.getItem("khoUserGlassId")) || null;

        if (typePhieu == LOAI_PHIEU_KHO.XUAT) {
          const khoXuatId = glassStore.listStoreXuat?.find(
            e => e?.id == khoUserId
          )?.id;
          formReceiptDto.setFieldValue("khoXuatId", khoXuatId);
          dispatch(setKhoXuatId(khoXuatId));
        }
        if (typePhieu == LOAI_PHIEU_KHO.NHAP) {
          const khoNhapId = glassStore.listStoreNhap?.find(
            e => e?.id == khoUserId
          )?.id;
          formReceiptDto.setFieldValue("khoNhapId", khoNhapId);
          dispatch(setKhoNhapId(khoNhapId));
        }
      }
    };
    setDefaultStore();
  }, [typeForm, typePhieu, glassStore.listStoreNhap, glassStore.listStoreXuat]);
  useEffect(() => {
    setData([]);
    formTable.setFieldValue("listGlassesReceiptDetailDto", []);
    if (typeForm == LOAI_FORM.DA_TAO) {
      getDetailReceipt(selectedRecord?.id);
      dispatch(setStatusPhieu(selectedRecord?.tinhTrang));
    }
  }, [selectedRecord, typeForm]);
  useEffect(() => {
    if (selectedGlassExport.length > 0) {
      setData(
        selectedGlassExport.map(e => ({
          ...e,
          soLuongNhap: e.xuatDuKien,
          // ngaySanXuat: moment(e.ngaySanXuat),
          // ngayHetHan: moment(e.ngayHetHan),
          // createDate: moment(e?.createDate),
          // khoId: e.khoId,
          thanhTien: Number(e?.xuatDuKien || 0) * Number(e?.donGiaNhap || 0),
        }))
      );
      formTable.setFieldValue(
        "listGlassesReceiptDetailDto",
        selectedGlassExport.map(e => ({
          ...e,
          soLuongNhap: e.xuatDuKien,
          // ngaySanXuat: moment(e.ngaySanXuat),
          // ngayHetHan: moment(e.ngayHetHan),
          // createDate: moment(e?.createDate),
          // khoId: e.khoId,
          thanhTien: Number(e?.xuatDuKien || 0) * Number(e?.donGiaNhap || 0),
        }))
      );

      dispatch(setKhoXuatId(selectedGlassExport[0]?.khoId));
      formReceiptDto.setFieldValue(
        "khoXuatId",
        selectedGlassExport[0]?.storeId
      );
    }
  }, [selectedGlassExport]);

  useEffect(() => {
    dispatch(getListStorePhanQuyen());
    dispatch(getListStoreNhap());
    dispatch(getListStoreXuat());
    dispatch(getListSupplierAPI(1, 100));
    dispatch(getListXuatXuAPI(1, 100));
  }, []);

  useEffect(() => {
    if (detailRecord && typeForm == LOAI_FORM.DA_TAO) {
      setFieldsValue(detailRecord?.receiptDto);
      if (typePhieu == LOAI_PHIEU_KHO.XUAT) {
        dispatch(setKhoXuatId(detailRecord?.receiptDto?.khoXuatId));
      }
    }
    // else {
    //   form.resetFields();
    // }
    if (detailRecord) {
      dispatch(setKhoNhapId(detailRecord?.receiptDto?.khoNhapId));
      dispatch(setKhoXuatId(detailRecord?.receiptDto?.khoXuatId));
      setData([
        ...detailRecord.listGlassesReceiptDetailDto?.map(e => ({
          ...e,
          tonKho: e?.soLuongTon,
          key: randomId(),
        })),
      ]);
      formTable.setFieldsValue({
        listGlassesReceiptDetailDto:
          detailRecord.listGlassesReceiptDetailDto?.map(e => ({
            ...e,
            tonKho: e?.soLuongTon,
          })),
      });
      console.log(formTable.getFieldValue("listGlassesReceiptDetailDto"));
      // setData([]);
    }
  }, [detailRecord]);

  useEffect(() => {
    if (typePhieu == LOAI_PHIEU_KHO.NHAP) {
      setTextTypePhieu("nhập kho");
      const newColumns = columnsTable;
      newColumns.find(e => e.dataIndex == "tonKho").show = false;
      setColumns([...newColumns]);
    }
    if (typePhieu == LOAI_PHIEU_KHO.XUAT) {
      setTextTypePhieu("xuất kho");
      const newColumns = columnsTable;
      newColumns.find(e => e.dataIndex == "tonKho").show = true;

      setColumns([...newColumns]);
    }
  }, [typePhieu]);
  const getDetailReceipt = async id => {
    try {
      setLoading(true);
      const res = await glassStoreService.getDetailReceipt(id);
      setLoading(false);
      dispatch(setDetailRecord(res));
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi khi thấy thông tin chi tiết phiếu");
    }
  };
  const getValueReceipt = async (tinhTrang, loaiPhieu) => {
    await formReceiptDto.validateFields();
    const formValue = formReceiptDto.getFieldsValue();
    const nhaCungCapId = glassStore.listSupplier?.find(
      e => e?.name == formValue?.nhaCungCap
    )?.id;
    const receiptDto = {
      ...formValue,
      tinhTrang: tinhTrang,
      loaiPhieu: loaiPhieu,
      nhomPhieu: "KI",
      nhaCungCapId: nhaCungCapId,
    };
    if (data.length == 0) {
      Notification("error", "Chưa chọn thuốc trong bảng");
      return false;
    } else if (
      formReceiptDto.getFieldValue("khoXuatId") ==
      formReceiptDto.getFieldValue("khoNhapId")
    ) {
      Notification("error", "Không được chọn kho nhập và kho xuất trùng nhau");
      return false;
    } else {
      console.log(formTable.getFieldValue("listGlassesReceiptDetailDto"));
      return {
        receiptDto: receiptDto,
        listGlassesReceiptDetailDto: formTable
          .getFieldValue("listGlassesReceiptDetailDto")
          ?.map(e => ({...e, soLo: e?.soLo?.toString()?.trim()})),
      };
    }
  };
  const navigateToTabList = () => {
    if (typePhieu == LOAI_PHIEU_KHO.XUAT) {
      dispatch(setActiveKey(tabKeys.GLASSES_STOREHOUSE.EXPORT));
    }
    if (typePhieu == LOAI_PHIEU_KHO.NHAP) {
      dispatch(setActiveKey(tabKeys.GLASSES_STOREHOUSE.IMPORT));
    }
  };
  const setFieldsValue = data => {
    const formValue = {
      ...data,
      ngayHoanThanh: data?.ngayHoanThanh ? moment(data?.ngayHoanThanh) : null,
      ngayDuTru: data?.ngayDuTru ? moment(data?.ngayDuTru) : null,
      ngayHoaDon: data?.ngayHoaDon ? moment(data?.ngayHoaDon) : null,
    };
    formReceiptDto.setFieldsValue(formValue);
  };
  useEffect(() => {
    if (statusPhieu == TT_PHIEU_KHO.CHO_DUYET) {
      setTextStatusPhieu("Chờ duyệt");
    }
    if (statusPhieu == TT_PHIEU_KHO.DA_DUYET) {
      setTextStatusPhieu("Đã duyệt");
    }
    if (statusPhieu == TT_PHIEU_KHO.NHAP) {
      setTextStatusPhieu("Nháp");
    }
    if (statusPhieu == TT_PHIEU_KHO.HOAN_THANH) {
      setTextStatusPhieu("Hoàn thành");
    }
    formReceiptDto.setFieldValue("tinhTrang", statusPhieu);
  }, [statusPhieu]);
  const reset = () => {
    dispatch(setSelectGlassExport([]));
    dispatch(setDetailRecord(null));
    dispatch(setSelectedRecord(null));
    dispatch(setKhoXuatId(null));
    dispatch(setKhoNhapId(null));
    dispatch(setTypeForm(null));
    // setData([]);
  };
  const setOnChangeStore = () => {
    fields.find(e => e.name == "khoNhapId").onChange = e => {
      dispatch(setKhoNhapId(e));
      const required =
        glassStore.listStoreXuat?.find(store => store.id == e)?.name ==
          "Các Kho nhà cung cấp" && typePhieu == LOAI_PHIEU_KHO.XUAT;

      fields.find(e => e?.name == "soHoaDon").rules = required
        ? [
            {required: true, message: "Chưa nhập số hóa đơn"},
            {max: 12, message: "Tối đa nhập 12 kí tự"},
          ]
        : [];
      fields.find(e => e?.name == "nhaCungCap").rules = required
        ? [{required: true, message: "Chưa chọn nhà cung cấp"}]
        : [];
      setDataFields([...fields]);
    };
    fields.find(e => e.name == "khoXuatId").onChange = e => {
      dispatch(setKhoXuatId(e));
    };

    setDataFields([...fields]);
  };
  const titleConfirm = () => {
    if (
      typeForm == LOAI_FORM.TAO_MOI ||
      (typeForm == LOAI_FORM.DA_TAO && statusPhieu == TT_PHIEU_KHO.NHAP)
    ) {
      return "Đồng ý hủy phiếu";
    }
    if (typeForm == LOAI_FORM.DA_TAO && statusPhieu == TT_PHIEU_KHO.CHO_DUYET) {
      return "Từ chối duyệt phiếu";
    } else {
      return "";
    }
  };
  const cancel = async () => {
    if (statusPhieu == TT_PHIEU_KHO.NHAP) {
      const receiptDto = {
        ...formReceiptDto.getFieldsValue(),
        tinhTrang: TT_PHIEU_KHO.HUY_PHIEU,
        loaiPhieu: typePhieu,
      };
      const data = {receiptDto: receiptDto, listGlassesReceiptDetailDto: []};
      try {
        setLoadingBtnCancel(true);
        await glassStoreService.updateImportForm(data);
        reset();
        setLoadingBtnCancel(false);
        navigateToTabList();
      } catch (error) {
        setLoadingBtnCancel(false);
        Notification(
          "error",
          error?.response?.data ??
            `Đã có lỗi khi hủy thông tin phiếu ${textTypePhieu}`
        );
      }
    }
    if (statusPhieu == TT_PHIEU_KHO.CHO_DUYET) {
      const receiptDto = {
        ...formReceiptDto.getFieldsValue(),
        tinhTrang: TT_PHIEU_KHO.TU_CHOI,
        loaiPhieu: typePhieu,
      };
      const data = {receiptDto: receiptDto, listGlassesReceiptDetailDto: []};
      modalRef.current?.openModal();
      setDataDeny(data);
    }
  };
  const handleDeny = async description => {
    let data = dataDeny;
    data = {
      ...data,
      receiptDto: {...data.receiptDto, description: description},
    };
    try {
      await glassStoreService.updateImportForm(data);
      modalRef.current?.closeModal();

      reset();
      navigateToTabList();
    } catch (error) {
      Notification(
        "error",
        error?.response?.data ??
          ` Đã có lỗi khi từ chối thông tin phiếu ${textTypePhieu}`
      );
    }
  };
  const save = async () => {
    if (typeForm == LOAI_FORM.TAO_MOI) {
      var data = await getValueReceipt(TT_PHIEU_KHO.NHAP, typePhieu);
      if (data) {
        try {
          setLoadingBtnSave(true);
          const res = await glassStoreService.postImportForm(data);
          dispatch(setTypeForm(LOAI_FORM.DA_TAO));
          dispatch(setSelectedRecord(res?.receiptDto));
          // dispatch(setDetailRecord(res));
          setLoadingBtnSave(false);
          Notification("success", `Tạo phiếu ${textTypePhieu} thành công`);
          // reset();
          // navigateToTabList();
        } catch (error) {
          setLoadingBtnSave(false);

          Notification(
            "error",
            Notification("success", error?.response?.data ?? "Đã có lỗi")
          );
        }
      }
    }
    if (typeForm == LOAI_FORM.DA_TAO) {
      var data = await getValueReceipt(statusPhieu, typePhieu);
      if (data) {
        try {
          setLoadingBtnSave(true);
          const res = await glassStoreService.updateImportForm(data);
          Notification("success", `Đã lưu thông tin phiếu ${textTypePhieu}`);
          dispatch(setSelectedRecord(res?.receiptDto));
          setLoadingBtnSave(false);
          // reset();

          // navigateToTabList();
        } catch (error) {
          setLoadingBtnSave(false);
          Notification(
            "error",
            error?.response?.data ??
              `Đã có lỗi khi lưu thông tin phiếu ${textTypePhieu}`
          );
        }
      }
    }
  };
  useEffect(() => {
    const disableFields = () => {
      const listKey = [
        "soHoaDon",
        "tieuDe",
        "khoNhapId",
        "khoXuatId",
        "nhaCungCap",
        "nguoiLap",
        "ngayDuTru",
        "nguoiGiao",
        "nguoiNhan",
        "ngayHoanThanh",
        "ngayHoaDon",
        "ghiChu",
      ];
      listKey.forEach(key => {
        dataFields.find(e => e?.name == key).disable =
          statusPhieu == TT_PHIEU_KHO.HOAN_THANH;
      });

      setDataFields([...dataFields]);
    };
    disableFields();
  }, [statusPhieu]);
  const send = async () => {
    if (statusPhieu == TT_PHIEU_KHO.NHAP) {
      var data = await getValueReceipt(TT_PHIEU_KHO.CHO_DUYET, typePhieu);
      if (data) {
        try {
          setLoadingBtnSend(true);
          let res;
          if (typeForm == LOAI_FORM.DA_TAO) {
            res = await glassStoreService.updateImportForm(data);
          }
          if (typeForm == LOAI_FORM.TAO_MOI) {
            res = await glassStoreService.postImportForm(data);
          }
          dispatch(setTypeForm(LOAI_FORM.DA_TAO));
          dispatch(setSelectedRecord(res?.receiptDto));
          setLoadingBtnSend(false);
          Notification("success", `Đã gửi thông tin phiếu ${textTypePhieu}`);
          // navigateToTabList();
          // reset();
        } catch (error) {
          setLoadingBtnSend(false);
          Notification("error", error?.response?.data ?? "Đã có lỗi");
        }
      }
    } else {
      Notification(
        "warning",
        `Không thể gửi duyệt phiếu ở trạng thái ${textStatusPhieu}`
      );
    }
  };
  const complete = async () => {
    if (statusPhieu == TT_PHIEU_KHO.CHO_DUYET) {
      const data = await getValueReceipt(TT_PHIEU_KHO.HOAN_THANH, typePhieu);
      // const isValid = validateTable();
      if (data) {
        setLoadingBtnComplete(true);
        try {
          const res = await glassStoreService.updateImportForm(data);
          dispatch(setSelectedRecord(res?.receiptDto));
          Notification(
            "success",
            `Đã cập nhật phiếu ${textTypePhieu} thành trạng thái hoàn thành`
          );
          setLoadingBtnComplete(false);
          // navigateToTabList();
          // reset();
        } catch (error) {
          Notification("error", error?.response?.data ?? "Đã có lỗi");
          setLoadingBtnComplete(false);
        }
      }
    } else {
      Notification("warning", "Chỉ hoàn thành khi ở trạng thái Chờ duyệt");
    }
  };
  const setTongTien = tongGiaTriDon => {
    formReceiptDto.setFieldValue("tongGiaTri", toNumber(tongGiaTriDon));
  };

  const setFieldSupplierShow = () => {
    dataFields.find(e => e.name == "nhaCungCap").hide =
      typePhieu == LOAI_PHIEU_KHO.DU_TRU;
    dataFields.find(e => e.name == "nhaCungCap").rules =
      typePhieu == LOAI_PHIEU_KHO.NHAP
        ? [{required: true, message: "Chưa chọn nhà cung cấp"}]
        : [];

    dataFields.find(e => e.name == "khoXuatId").rules =
      typePhieu != LOAI_PHIEU_KHO.NHAP
        ? [{required: true, message: "Chưa chọn kho xuất/cấp"}]
        : [];
    setDataFields([...dataFields]);
  };
  const setFieldSoHoaDonShow = () => {
    dataFields.find(e => e.name == "soHoaDon").hide =
      typePhieu == LOAI_PHIEU_KHO.DU_TRU;
    dataFields.find(e => e.name == "soHoaDon").rules =
      typePhieu != LOAI_PHIEU_KHO.NHAP
        ? []
        : [
            {required: true, message: "Chưa nhập số hóa đơn"},
            {max: 12, message: "Tối đa nhập 12 kí tự"},
          ];
    setDataFields([...dataFields]);
  };
  return (
    <Spin spinning={loading}>
      <div className="detail-ticket-tab">
        <div className="container">
          <Typography.Text style={{fontWeight: "bold"}}>
            Thông tin phiếu {textTypePhieu}
          </Typography.Text>
          <Divider type="horizontal" style={{margin: 0, marginBottom: 8}} />
          <Form form={formReceiptDto}>
            <Space direction="vertical" style={{width: "100%"}}>
              <Row gutter={[16, 8]}>
                <InputFields data={dataFields} />
              </Row>
              <Row justify={"end"}>
                <Space>
                  <Button
                    icon={<Icon.file />}
                    className="btn-sub"
                    onClick={() => {
                      receiptRef.current?.openModal();
                    }}
                  >
                    In phiếu
                  </Button>

                  <Popconfirm
                    title={titleConfirm}
                    onConfirm={cancel}
                    okText="Đồng ý"
                    cancelText="Hủy"
                    disabled={
                      typeForm == LOAI_FORM.DA_TAO &&
                      (statusPhieu == TT_PHIEU_KHO.DA_DUYET ||
                        statusPhieu == TT_PHIEU_KHO.HOAN_THANH)
                    }
                  >
                    <Button
                      type="primary"
                      danger
                      icon={<Icon.close></Icon.close>}
                      disabled={
                        typeForm == LOAI_FORM.DA_TAO &&
                        statusPhieu != TT_PHIEU_KHO.NHAP &&
                        statusPhieu != TT_PHIEU_KHO.CHO_DUYET
                      }
                      loading={loadingBtnCancel}
                    >
                      Hủy
                    </Button>
                  </Popconfirm>
                  <Button
                    type="primary"
                    icon={<Icon.save />}
                    onClick={save}
                    loading={loadingBtnSave}
                    disabled={
                      typeForm == LOAI_FORM.DA_TAO &&
                      statusPhieu != TT_PHIEU_KHO.NHAP &&
                      statusPhieu != TT_PHIEU_KHO.CHO_DUYET
                    }
                  >
                    Lưu lại
                  </Button>

                  <Button
                    className="btn-sub"
                    icon={<Icon.upload />}
                    onClick={send}
                    loading={loadingBtnSend}
                    disabled={
                      typeForm == LOAI_FORM.DA_TAO &&
                      statusPhieu != TT_PHIEU_KHO.NHAP
                    }
                  >
                    Gửi phiếu
                  </Button>
                  <Button
                    type="primary"
                    onClick={complete}
                    disabled={
                      statusPhieu != TT_PHIEU_KHO.CHO_DUYET &&
                      statusPhieu != TT_PHIEU_KHO.NHAP
                    }
                    loading={loadingBtnComplete}
                  >
                    Hoàn thành
                  </Button>
                  {/* <Button
                  type="ghost"
                  className="btn-sub"
                  icon={<Icon.printer  />}
                >
                  In số lô
                </Button> */}
                </Space>
              </Row>
            </Space>
          </Form>
        </div>
        <div className="container">
          <Typography.Text style={{fontWeight: "bold"}} ellipsis={true}>
            Bảng vật tư đưa vào phiếu
          </Typography.Text>
          <Form form={formTable}>
            <TableInputAdd
              scroll={{x: 3000}}
              setData={setData}
              isCheckbox={undefined}
              isPagination={false}
              data={data}
              form={formTable}
              name="listGlassesReceiptDetailDto"
              column={columns}
              disabled={statusPhieu == TT_PHIEU_KHO.HOAN_THANH}
              setTongTien={setTongTien}
            ></TableInputAdd>
          </Form>
        </div>
        <ModalCustom ref={modalRef} width={400} title={`Lý cho từ chối`}>
          <ModalDeny handleDeny={handleDeny}></ModalDeny>
        </ModalCustom>
        <ModalCustom
          wrapClassName="modal-print-form"
          ref={receiptRef}
          width={1100}
          centered
        >
          <ReceiptModal />
        </ModalCustom>
      </div>
    </Spin>
  );
};

export default Detail;
